import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LightbulbBright from './icon-lightbulb-bright.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LightbulbBright {...validProps} />;
}
SvgComponent.iconName = 'lightbulb-bright';

/**
 * @deprecated This is a legacy icon
 */
export const LightbulbBrightIcon = svgIconWrapper(SvgComponent);
